import { CurrencyText, TranslatedText } from "@/components/common/text";

export const MyOfferText = ({ offer }) => {
    const isQuote = offer.type === "quote";
    const isBooking = offer.type === "booking";

    // Determine status category
    const isPending = ["PENDING", "NOT_SUBMITTED"].includes(offer.status);
    const isAccepted = isQuote ? offer.status === "ACCEPTED" : offer.status === "CONFIRMED";
    const isDeclined = isQuote ? offer.status === "DECLINED" : offer.status === "REJECTED";
    const isCanceled = ["CANCELLED"].includes(offer.status);
    const isExpired = ["EXPIRED"].includes(offer.status);

    // Get the load's offer rate and bid amount
    const loadOfferRate = offer.loadBoardItem?.offerRate;
    const offerRate = offer.offerRate;

    // Generate message based on type and status
    if (isQuote) {
        if (isPending) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>offer is being processed.</TranslatedText>
                </div>
            );
        } else if (isAccepted) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>offer has being accepted.</TranslatedText>
                </div>
            );
        } else if (isDeclined) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>bid is declined.</TranslatedText>
                </div>
            );
        } else if (isExpired) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>bid is expired.</TranslatedText>
                </div>
            );
        } else if (isCanceled) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You have canceled the bid for</TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        }
    }

    if (isBooking) {
        if (isPending) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>booking is being processed.</TranslatedText>
                </div>
            );
        } else if (isAccepted) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You have booked this load for</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                </div>
            );
        } else if (isDeclined) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>Your booking for</TranslatedText>
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />
                    <TranslatedText>is canceled.</TranslatedText>
                </div>
            );
        } else if (isCanceled) {
            return (
                <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
                    <TranslatedText>You have canceled booking for </TranslatedText>
                    {loadOfferRate !== offerRate ? (
                        <CurrencyText
                            num={loadOfferRate}
                            round
                            className="font-medium text-cm-p-text-secondary text-sm/[22px] line-through"
                        />
                    ) : null}
                    <CurrencyText num={offerRate} round className="font-medium text-cm-p-text-primary text-sm/[22px]" />.
                </div>
            );
        }
    }

    console.log("cera offer", offer);
    // Fallback
    return (
        <div className="inline-flex gap-1 text-cm-p-text-primary text-sm/[22px]">
            <TranslatedText>Status unknown</TranslatedText>
        </div>
    );
};
